import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import FrozenScreen from "../pages/FrozenScreen";

export default function RoleRoute({ allow, children }) {
  const { user, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="lms-root flex items-center justify-center min-h-screen">
        <div className="lms-shimmer w-64 h-8" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Iter 157: a frozen student can only see the FrozenScreen. The
  // backend also enforces this (HTTP 423 on every other endpoint) so
  // even a direct URL hit can't bypass it — the frontend check just
  // avoids the extra failed request and keeps the UX clean.
  if (user.role === "student" && user.is_frozen) {
    return <FrozenScreen />;
  }

  if (allow && !allow.includes(user.role)) {
    const fallback =
      user.role === "admin" ? "/admin" : user.role === "mentor" ? "/mentor" : "/student";
    return <Navigate to={fallback} replace />;
  }

  // Force-first-login password change (except on the change page itself).
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  return children;
}
